class ProductListCategory extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(this).css({"opacity":"1"});

      var swiper = new Swiper(".productcategoryslider", {
      slidesPerView:3.5,
      spaceBetween:25,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
          320: {
            slidesPerView:3.5,   
            spaceBetween: 20
          },
          480: {
            slidesPerView:3.5,
            spaceBetween: 25
          },
          640: {
            slidesPerView:4.5,
            spaceBetween: 25
          },
         990: {
            slidesPerView:6.5,
            spaceBetween: 25
         },
         1024: {
           slidesPerView:8.5,
           spaceBetween: 25
         },
        1200: {
          slidesPerView:10.5,
          spaceBetween: 30
         },
        1441:{
          slidesPerView:11.5,
          spaceBetween: 35
        }
      },
    });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);          
  }
}
customElements.define("product-list-category", ProductListCategory);




//--------- New Product Template Frame Drawer -----------------//


function toggleAddon() {
  var selectedValue = $('input[name="Frame Color"]:checked').val();
  if (!selectedValue) return;

  var value = selectedValue.toUpperCase().trim();

  var $wrapper = $('.custom_addon_item_wrapper');
  var $checkbox = $wrapper.find('input[type="checkbox"]');

  if (value === 'UNFRAMED POSTER' || value === 'CANVAS' || value === 'UNFRAMED') {
    $wrapper.css('opacity', '0.5');
    $checkbox
      .prop('disabled', true)
      .prop('checked', false)
      .css('cursor', 'not-allowed');
  } else {
    $wrapper.css('opacity', '1');
    $checkbox
      .prop('disabled', false)
      .css('cursor', 'pointer');
  }
}



// Run on page load
$(document).ready(function () {
  toggleAddon();
});

// Run when Type option changes
$(document).on('change', 'input[name="Frame Color"]', function () {
  toggleAddon();
});

//------------
// Main Drawer

  $('.trigger_frame_drawer').click(function () {
    $('#custom_frame_drawer_container').addClass('open');
    $('.drawer-color-option').removeClass('active');
    $('.drawer-color-option[data-value="UNFRAMED POSTER"]').addClass('active');
    $('.drawer-color-option[data-value="CANVAS"]').addClass('active');
    $('.drawer-color-option[data-value="UNFRAMED"]').addClass('active');
      $('html').addClass('js-drawer-open lock-scroll');
      console.log('clicked');
      $('.variant-input[data-value="UNFRAMED POSTER"] label[data-varcolorproduct="UNFRAMED POSTER"]').trigger('click');
      $('.variant-input[data-value="CANVAS"] label[data-varcolorproduct="CANVAS"]').trigger('click');            
      $('.variant-input[data-value="UNFRAMED"] label[data-varcolorproduct="UNFRAMED"]').trigger('click');            
    });
    
  $('.custom_frame_drawer_overlay').click(function () {
        $('.custom_information_drawer').removeClass('open');
    $('.custom_item_info_drawer').removeClass('open');
    $('.custom_item_frame_info_drawer').removeClass('open');

    $('#custom_frame_drawer_container').removeClass('open');
    $('html').removeClass('js-drawer-open lock-scroll');
    $('.variant-input[data-value="UNFRAMED POSTER"] label[data-varcolorproduct="UNFRAMED POSTER"]').trigger('click');
    $('.variant-input[data-value="CANVAS"] label[data-varcolorproduct="CANVAS"]').trigger('click');
    $('.variant-input[data-value="UNFRAMED"] label[data-varcolorproduct="UNFRAMED"]').trigger('click'); 
     $('#add-to-cart-btn').click();
  });
  
  $('.custom_frame_drawer .frame_drawer_close').click(function () {
      $('html').addClass('js-drawer-open lock-scroll');
          $('.custom_information_drawer').removeClass('open');
    $('.custom_item_info_drawer').removeClass('open');
    $('.custom_item_frame_info_drawer').removeClass('open');

    $('#custom_frame_drawer_container').removeClass('open');
    $('.variant-input[data-value="UNFRAMED POSTER"] label[data-varcolorproduct="UNFRAMED POSTER"]').trigger('click');
    $('.variant-input[data-value="CANVAS"] label[data-varcolorproduct="CANVAS"]').trigger('click');
    $('.variant-input[data-value="UNFRAMED"] label[data-varcolorproduct="UNFRAMED"]').trigger('click'); 
     $('#add-to-cart-btn').click();
  });
 

  $('.custom_frame_drawer .add_without_frame').click(function () {
    $('#custom_frame_drawer_container').removeClass('open');
  $('html').removeClass('js-drawer-open lock-scroll');
    $('.variant-input[data-value="UNFRAMED POSTER"] label[data-varcolorproduct="UNFRAMED POSTER"]').trigger('click');
    $('.variant-input[data-value="CANVAS"] label[data-varcolorproduct="CANVAS"]').trigger('click');
    $('.variant-input[data-value="UNFRAMED"] label[data-varcolorproduct="UNFRAMED"]').trigger('click'); 
     $('#add-to-cart-btn').click();
  });


  // info drawer
  $('.custom_frame_drawer .custom_frame_head_info').click(function () {
    $('.custom_information_drawer').addClass('open');
  });
  $('.custom_information_drawer .frame_drawer_close').click(function () {
    $('.custom_information_drawer').removeClass('open');
  });

  // item info drawer
  $('.custom_addon_item_wrapper .item_info').click(function () {
    $('.custom_item_info_drawer').addClass('open');
  });
  $('.custom_item_info_drawer .frame_drawer_close').click(function () {
    $('.custom_item_info_drawer').removeClass('open');
  });

  // item Frame info drawer
  $('.custom_frame_drawer .custom_frame_list_label').click(function () {
    $('.custom_item_frame_info_drawer').addClass('open');
  });
  $('.custom_item_frame_info_drawer .frame_drawer_close').click(function () {
    $('.custom_item_frame_info_drawer').removeClass('open');
  });

  // New Product Template Frame Drawer /////////
  
  
  
  // New Product Template Frame Drawer button/////////

(function ($) {

  function updateDrawerPrice() {

    var $checked = $('.variant-input-wrap-frame input[type="radio"]:checked');

    if ($checked.length > 0) {

      var pricehtml = $checked
        .closest('.variant-input') 
        .find('.option-price')
        .html();
      
      $('#drawertrigger .price-wrapper').html(pricehtml);
      // $('#custom_frame_drawer_container .custom_addon_item_wrapper .item_price').html(pricehtml);

    }
  }

 
function updateDrawerframePrice() {

  var $active = $('.drawer-color-option.active');

  if ($active.length === 0) return;

  var selectedValue = $active.data('value');

  // UNFRAMED CASE
  if (selectedValue === 'UNFRAMED POSTER' || selectedValue === 'CANVAS' || selectedValue === 'Canvas' || selectedValue === 'UNFRAMED' ) {

    $('#addtocarttrigger .addtocarttext')
      .text('Continue without frame');

    $('#addtocarttrigger .price-wrapper').html('');

  } else {

    var pricehtml = $active.find('.frameprice-new').html() || '';

    $('#addtocarttrigger .addtocarttext').html(
      'ADD FRAME TO CART <span>|</span> <span class="price-wrapper"></span>'
    );

    $('#addtocarttrigger .price-wrapper')
      .html(pricehtml);
  }
}





 $(document).on('click', '.drawer-color-option', function () {

    const value = $(this).data('value');

    const originalInput = document.querySelector(
        'fieldset[name="Frame Color"] input[type="radio"][value="'+value+'"]'
    );

    if (!originalInput) return;

    if (originalInput.disabled) {
        console.log('Variant combination not available');
        return;
    }

    originalInput.checked = true;
    originalInput.dispatchEvent(new Event('change', { bubbles: true }));

    $('.drawer-color-option').removeClass('active');
    $(this).addClass('active');
    
     updateDrawerframePrice(); 

});







  function ensureSelectedVariant() {

    var $checked = $('.variant-input-wrap-frame input[type="radio"]:checked');

    if ($checked.length === 0) {
      $('.variant-input-wrap-frame input[type="radio"]').first().prop('checked', true);
    }
  }

  // When DOM is ready
  $(document).ready(function () {

    ensureSelectedVariant();

   
    setTimeout(function () {
      updateDrawerPrice();
      updateDrawerframePrice();
    }, 100);

  });


  $(document).on('change', '.variant-input-wrap-frame input[type="radio"]', function () {
    updateDrawerPrice();
    updateDrawerframePrice();
  });

})(jQuery);



  // New Product Template Frame Drawer button/////////


$(document).on('click', '#addtocarttrigger', function (e) {
  e.preventDefault();

  $('#custom_frame_drawer_container').removeClass('open');

  var $checkedAddon = $('.item_check input[type="checkbox"]:checked');

  // Agar addon checked hai
  if ($checkedAddon.length) {
    var variantId = $checkedAddon.data('varid');

    // Add addon product first
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: 1    
      },
      dataType: 'json',
      success: function () {
        // After addon added, add main product
        $('#add-to-cart-btn').trigger('click');
      }
    });

  } else { 
    $('#add-to-cart-btn').trigger('click');
  } 
   
});
 



// frame drawer varaint price

// frame drawer varaint price




function updateFramePricesBySize() {

  var size = $('fieldset[name="Size"] input:checked').val();
  if (!size) return;

  /* ===============================
     BASE = UNFRAMED POSTER (THIS SIZE)
  ================================ */
  // var $unframedVariant = $('.all-variant-inner').filter(function () {
  //   return (
  //     $(this).data('option1') == size &&
  //     $(this).data('option2') == 'UNFRAMED POSTER'
  //   );
  // }).first();
  var $unframedVariant = $('.all-variant-inner').filter(function () {
  var opt2 = ($(this).data('option2') || '').toString().toLowerCase();
  return (
    $(this).data('option1') == size &&
    (opt2.includes('unframed') || opt2.includes('canvas'))
  );
}).first();

  if (!$unframedVariant.length) return;

  var basePrice = Number($unframedVariant.data('price')) || 0;
  var baseComp  = Number($unframedVariant.data('compprice')) || 0;

  /* ===============================
     UPDATE ALL FRAME OPTIONS
  ================================ */
  // $('fieldset[name="Frame Color"] .variant-input').each(function () {
  $('.drawer-frame-options .drawer-color-option').each(function () {

    var frameValue = $(this).data('value');
    var $priceBox  = $(this).find('.frameprice-new');

    /* UNFRAMED = ₹0 */
    if (frameValue === 'UNFRAMED POSTER' || frameValue === 'CANVAS' || frameValue === 'PRINT' || frameValue === 'UNFRAMED' ) {
      $priceBox.html('<span></span>');
      return;
    }

    /* Find variant for SIZE + FRAME */
    var $variant = $('.all-variant-inner').filter(function () {
      return (
        $(this).data('option1') == size &&
        $(this).data('option2') == frameValue
      );
    }).first();

    if (!$variant.length) {
      console.warn('Variant missing for:', size, frameValue);
      return;
    }

    var price = Number($variant.data('price')) || 0;
    var comp  = Number($variant.data('compprice')) || 0;

    var diffPrice = price - basePrice;
    var diffComp  = comp - baseComp;

    var sign = diffPrice > 0 ? '' : '';
    var html = sign + theme.Currency.formatMoney(diffPrice, theme.settings.moneyFormat);

    if (diffComp > diffPrice) {
      html += '<s>' + theme.Currency.formatMoney(diffComp, theme.settings.moneyFormat) + '</s>';
    }

    $priceBox.html(html);
  });
}

/* ONLY size drives price refresh */
$(document).on('change', 'fieldset[name="Size"] input', function () {
  updateFramePricesBySize();
});

/* Initial load */
$(document).ready(function () {
  updateFramePricesBySize();
});




class CustomProductGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(this).css({"opacity":"1"});

      var swiper = new Swiper(".custom-product-reviews", {
      slidesPerView:3.5,
      spaceBetween:8,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
          0: {
            slidesPerView:2.5,   
            spaceBetween: 10
          },
          360: {
            slidesPerView:3.2,
            spaceBetween: 10
          },
          430: {
            slidesPerView:4.2,
            spaceBetween: 10
          },
        768: {
            slidesPerView:6.2,
            spaceBetween: 10
        },
        1024: {
          slidesPerView:7.2,
          spaceBetween: 10
        },
        1200: {
          slidesPerView:8,
          spaceBetween: 10
        },
        1401: {
        slidesPerView:10,
        spaceBetween: 10
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    $(this).css({"opacity":"1"});

    const FALLBACK_REVIEW_COUNT = '4,224';
const FALLBACK_REVIEW_RATING = '4.8';
const STORAGE_KEY = 'saved_review_count';
const RATING_STORAGE_KEY = 'saved_review_rating';
const COOKIE_KEY = 'saved_review_count';
const RATING_COOKIE_KEY = 'saved_review_rating';

function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie =
    name +
    '=' +
    encodeURIComponent(value) +
    '; expires=' +
    d.toUTCString() +
    '; path=/';
}

function getCookie(name) {
  const match = document.cookie.match(
    new RegExp(
      '(?:^|; )' +
        name.replace(/([.$?*|{}()\\[\]\\/\\+^])/g, '\\$1') +
        '=([^;]*)'
    )
  );
  return match ? decodeURIComponent(match[1]) : '';
}

function getSavedReviewCount() {
  const localValue = localStorage.getItem(STORAGE_KEY);
  const sessionValue = sessionStorage.getItem(STORAGE_KEY);
  const cookieValue = getCookie(COOKIE_KEY);

  return localValue || sessionValue || cookieValue || FALLBACK_REVIEW_COUNT;
}

function getSavedReviewRating() {
  const localValue = localStorage.getItem(RATING_STORAGE_KEY);
  const sessionValue = sessionStorage.getItem(RATING_STORAGE_KEY);
  const cookieValue = getCookie(RATING_COOKIE_KEY);

  return localValue || sessionValue || cookieValue || FALLBACK_REVIEW_RATING;
}

function saveReviewCount(value) {
  localStorage.setItem(STORAGE_KEY, value);
  sessionStorage.setItem(STORAGE_KEY, value);
  setCookie(COOKIE_KEY, value, 30);
}

function saveReviewRating(value) {
  localStorage.setItem(RATING_STORAGE_KEY, value);
  sessionStorage.setItem(RATING_STORAGE_KEY, value);
  setCookie(RATING_COOKIE_KEY, value, 30);
}

function formatReviewCount(value) {
  value = (value || '').toString().replace(/\D/g, '');
  if (!value || value === '0') return '';
  return Number(value).toLocaleString();
}

function formatReviewRating(value) {
  value = (value || '').toString().trim();
  return value || '';
}

function updateReviewText(value) {
  if (!value) return;

  $('.custom-richtext-content-dynamic').each(function () {
    let html = $(this).html();

    if (!html) return;

    if (html.indexOf('$totalreviewcount') !== -1) {
      html = html.replace(/\$totalreviewcount/g, value);
    } else {
      html = html.replace(/(Based on\s*)([\d,]+)(\s*reviews?)/gi, '$1' + value + '$3');
      html = html.replace(/([\d,]+)(\s*Reviews?)/gi, value + '$2');
    }

    $(this).html(html);
  });

  $('.custom-richtext-content-dynamic .totalreviewcount').text(value);
}

function updateReviewTitle(rating) {
  if (!rating) return;

  $('.custom-review-title').each(function () {
    let html = $(this).html();

    if (!html) return;

    if (html.indexOf('$reviewrating') !== -1) {
      html = html.replace(/\$reviewrating/g, rating);
    } else {
      html = html.replace(/(\d+(\.\d+)?)/, rating);
    }

    $(this).html(html);
  });

  $('.custom-review-title .reviewrating').text(rating);
}

function getFreshReviewCount() {
  let freshReviewCount = '';

  const looxContainer = document.querySelector('.loox-trust-badge-container');

  if (looxContainer) {
    freshReviewCount = looxContainer.getAttribute('data-loox-raters') || '';
  }

  if (!freshReviewCount) {
    freshReviewCount = $('.loox-trust-badge-widget-ratings__raters-count').text().trim();
  }

  return formatReviewCount(freshReviewCount);
}

function getFreshReviewRating() {
  let freshReviewRating = '';

  const looxContainer = document.querySelector('.loox-trust-badge-container');

  if (looxContainer) {
    freshReviewRating = looxContainer.getAttribute('data-loox-rating') || '';
  }

  if (!freshReviewRating) {
    freshReviewRating = $('.loox-rating').first().text().trim();
  }

  return formatReviewRating(freshReviewRating);
}

function syncReviewCount() {
  const freshReviewCount = getFreshReviewCount();
  const freshReviewRating = getFreshReviewRating();

  let synced = false;

  if (freshReviewCount) {
    saveReviewCount(freshReviewCount);
    updateReviewText(freshReviewCount);
    synced = true;
  }

  if (freshReviewRating) {
    saveReviewRating(freshReviewRating);
    updateReviewTitle(freshReviewRating);
    synced = true;
  }

  return synced;
}

const savedReviewCount = getSavedReviewCount();
const savedReviewRating = getSavedReviewRating();

updateReviewText(savedReviewCount);
updateReviewTitle(savedReviewRating);

let pollAttempts = 0;
const maxPollAttempts = 30;

const reviewPollInterval = setInterval(function () {
  pollAttempts += 1;

  const synced = syncReviewCount();

  if (synced || pollAttempts >= maxPollAttempts) {
    clearInterval(reviewPollInterval);
  }
}, 300);

const looxObserver = new MutationObserver(function () {
  const synced = syncReviewCount();

  if (synced) {
    looxObserver.disconnect();
    clearInterval(reviewPollInterval);
  }
});

if (document.body) {
  looxObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true
  });
}

window.addEventListener('load', function () {
  syncReviewCount();

  setTimeout(function () {
    syncReviewCount();
  }, 500);

  setTimeout(function () {
    syncReviewCount();
  }, 1500);

  setTimeout(function () {
    syncReviewCount();
  }, 3000);
});

      const sectionId = this.getAttribute('data-sectionid');
      const sectionRoot = document.querySelector(`.custom-product-reviews-richtext-${sectionId}`);

      if (!sectionRoot) return;

      const popup = document.getElementById(`review-popup-${sectionId}`);
      if (!popup) return;

      const triggers = Array.from(sectionRoot.querySelectorAll('.review-popup-trigger'));
      if (!triggers.length) return;

      const overlay = popup.querySelector('.custom-review-popup__overlay');
      const closeBtn = popup.querySelector('.custom-review-popup__close');
      const prevBtn = popup.querySelector('.custom-review-popup__nav--prev');
      const nextBtn = popup.querySelector('.custom-review-popup__nav--next');

      const popupImage = popup.querySelector('.custom-review-popup__image');
      const popupName = popup.querySelector('.custom-review-popup__name');
      const popupContent = popup.querySelector('.custom-review-popup__content');
      const popupStars = popup.querySelector('.custom-review-popup__stars');

      let currentIndex = 0;

      function buildStars(total) {
        let html = '';
        total = parseInt(total || 0, 10);

        if (total < 0) total = 0;
        if (total > 5) total = 5;

        for (let i = 1; i <= total; i++) {
          html += `
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.825 21L7.45 13.975L2 9.25L9.2 8.625L12 2L14.8 8.625L22 9.25L16.55 13.975L18.175 21L12 17.275L5.825 21Z" fill="{{ section.settings.overlaytextcolor }}"/>
            </svg>
          `;
        }

        return html;
      }

      function updateNavState() {
        if (prevBtn) {
          prevBtn.classList.toggle('is-disabled', currentIndex === 0);
        }

        if (nextBtn) {
          nextBtn.classList.toggle('is-disabled', currentIndex === triggers.length - 1);
        }
      }

      function renderPopup(index) {
        const item = triggers[index];
        if (!item) return;

        popupImage.src = item.dataset.reviewImage || '';
        popupImage.alt = item.dataset.reviewName || '';

        popupName.textContent = item.dataset.reviewName || '';
        popupContent.innerHTML = item.dataset.reviewContent || '';
        popupStars.innerHTML = buildStars(item.dataset.reviewStars);

        currentIndex = index;
        updateNavState();
      }

      function openPopup(index) {
        renderPopup(index);
        popup.classList.add('is-active');
        document.body.classList.add('review-popup-open');
      }

      function closePopup() {
        popup.classList.remove('is-active');
        document.body.classList.remove('review-popup-open');
      }

      function nextSlide(e) {
        if (e) e.preventDefault();
        if (currentIndex >= triggers.length - 1) return;
        renderPopup(currentIndex + 1);
      }

      function prevSlide(e) {
        if (e) e.preventDefault();
        if (currentIndex <= 0) return;
        renderPopup(currentIndex - 1);
      }

      triggers.forEach(function(trigger, index) {
        trigger.onclick = function() {
          openPopup(index);
        };
      });

      if (overlay) {
        overlay.onclick = function() {
          closePopup();
        };
      }

      if (closeBtn) {
        closeBtn.onclick = function() {
          closePopup();
        };
      }

      if (nextBtn) {
        nextBtn.onclick = function(e) {
          if (nextBtn.classList.contains('is-disabled')) return;
          nextSlide(e);
        };
      }

      if (prevBtn) {
        prevBtn.onclick = function(e) {
          if (prevBtn.classList.contains('is-disabled')) return;
          prevSlide(e);
        };
      }

    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);          
  }
}
customElements.define("custom-product-reviews", CustomProductGallery);
